import { render } from "./EvalvationAIResults.vue?vue&type=template&id=f3d2780a"
import script from "./EvalvationAIResults.vue?vue&type=script&lang=js"
export * from "./EvalvationAIResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__